/**
 * 路由配置文件
 */
import { flatten } from 'lodash';
class RouteModal {
  constructor(lang) {
    const homeCom = () => import('../pages/homePages/index')
    const dictCom = () => import('../pages/dict/index')
    const routes = [
      {
        name: 'OnlineClaim',
        component: homeCom // OnlineClaim
      },
      {
        name: 'Dict',
        component: dictCom // OnlineClaim
      }
    ].map(item => {
      return {
        isCache: false,
        permission: 'all',
        route: {
          path: `/${lang}/${item.name}`,
          meta: {
            lang: lang
          },
          ...item
        }
      }
    })
    return routes;
  }
}
export default function () {
  const routers = ['zh', 'en', 'polish', 'spanish', 'turkish', 'dutch', 'hungary', 'zhtw', 'ptbr', 'germany', 'french', 'italian'].map(item => {
    return new RouteModal(item)
  })
  return [{
    permission: 'all',
    route: {
      path: '/',
      name: '/',
      meta: [],
      component: () => import('../pages/nil/index')
    }
  }, ...flatten(routers)]
}



// WEBPACK FOOTER //
// ./src/app/sitmap.js